import { Link } from 'react-router-dom'
import { LOGO_ALT, LOGO_MOBILE_PATH, STORE_NAME } from '@/lib/brand'
import { cn } from '@/lib/utils'
import { StoreImage } from '@/store/components/StoreImage'

interface StoreHeaderBrandProps {
  className?: string
}

/** Horizontal lockup used in the storefront top bar (mobile, tablet & desktop). */
export function StoreHeaderBrand({ className }: StoreHeaderBrandProps) {
  return (
    <Link
      to="/"
      aria-label={`${STORE_NAME} home`}
      className={cn('store-header-brand focus-ring min-w-0 shrink', className)}
    >
      <StoreImage
        src={LOGO_MOBILE_PATH}
        alt={LOGO_ALT}
        priority
        objectFit="contain"
        sizing="box"
        spinnerSize="sm"
        containerClassName="store-header-lockup"
        className="h-full w-auto max-h-full object-contain object-left"
      />
    </Link>
  )
}
